import Image1 from "../../assets/testimonial1.png";
import Image2 from "../../assets/testimonial2.png";
import Image3 from "../../assets/testimonial3.png";
import Image4 from "../../assets/testimonial4.png";
import Image5 from "../../assets/testimonial5.png";

export const Data = [
  {
    id: 1,
    image: Image1,
    title: "CartSaz",
    href: "https://alimoradpour-cartsaz.netlify.app/",
    source: "https://github.com/AliMoradpour/cartSaz",
  },
  {
    id: 2,
    image: Image2,
    title: "Shopping Site",
    source: "https://github.com/AliMoradpour/shopping_website",
  },
  {
    id: 3,
    image: Image3,
    title: "Inventory App",
    href: "https://zingy-kataifi-dab080.netlify.app",
    source: "https://github.com/AliMoradpour/inventorySite",
  },
  {
    id: 4,
    image: Image4,
    title: "Facebook Clone",
    href: "https://gentle-bombolone-ad438f.netlify.app/",
    source: "https://github.com/AliMoradpour/facebookUiClone",
  },
  {
    id: 5,
    image: Image5,
    title: "Digitize Shop",
    href: "https://gentle-bombolone-ad438f.netlify.app/",
    source: "https://github.com/AliMoradpour/DigiTizeShop",
  },
];
